var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responsive-box"},[_c('FormViewRun2',{attrs:{"actionVisible":false,"edit":false,"formId":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }